import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAnalysisModuleState } from '@shared/models';
import * as ResponseTypes from '@shared/models/analysis/analysis.response.type';
import {
    fetchSkillCategoryAnalysis,
    fetchSkillModules,
    fetchTrackProgressPerModule,
    fetchTrackProgressPerSkill,
} from '../queries';

const state: IAnalysisModuleState = {
    data: null,
    fetching: false,
    skillModules: [],
    fetchingSkillModules: false,
    trackAnalysisPerModule: null,
    fetchingTrackAnalysisPerModule: false,
    trackAnalysisPerSkill: [],
    fetchingTrackAnalysisPerSkill: false,
};

const anaylsisModuleSlice = createSlice({
    name: 'analysis-module',
    initialState: state,
    reducers: {
        setSkillCategoryAnalysis: (
            state,
            { payload }: PayloadAction<ResponseTypes.IFetchPerModuleAnalysisResponseType>
        ) => {
            state.data = payload;
        },
        setSkillModules: (state, { payload }: PayloadAction<ResponseTypes.IFetchSkillModules>) => {
            state.skillModules = payload;
        },
        setTrackPerModule: (state, { payload }: PayloadAction<ResponseTypes.IFetchTrackAnalysisPerModule>) => {
            state.trackAnalysisPerModule = payload;
        },
        setTrackPerSkill: (state, { payload }: PayloadAction<ResponseTypes.IFetchTrackAnalysisPerSkill>) => {
            state.trackAnalysisPerSkill = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSkillCategoryAnalysis.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchSkillCategoryAnalysis.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchSkillCategoryAnalysis.fulfilled, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchSkillModules.pending, (state) => {
            state.fetchingSkillModules = true;
        });
        builder.addCase(fetchSkillModules.rejected, (state) => {
            state.fetchingSkillModules = false;
        });
        builder.addCase(fetchSkillModules.fulfilled, (state) => {
            state.fetchingSkillModules = false;
        });
        builder.addCase(fetchTrackProgressPerModule.pending, (state) => {
            state.fetchingTrackAnalysisPerModule = true;
        });
        builder.addCase(fetchTrackProgressPerModule.rejected, (state) => {
            state.fetchingTrackAnalysisPerModule = false;
        });
        builder.addCase(fetchTrackProgressPerModule.fulfilled, (state) => {
            state.fetchingTrackAnalysisPerModule = false;
        });
        builder.addCase(fetchTrackProgressPerSkill.pending, (state) => {
            state.fetchingTrackAnalysisPerSkill = true;
        });
        builder.addCase(fetchTrackProgressPerSkill.rejected, (state) => {
            state.fetchingTrackAnalysisPerSkill = false;
        });
        builder.addCase(fetchTrackProgressPerSkill.fulfilled, (state) => {
            state.fetchingTrackAnalysisPerSkill = false;
        });
    },
});

export const { setSkillCategoryAnalysis, setSkillModules, setTrackPerModule, setTrackPerSkill } =
    anaylsisModuleSlice.actions;
export default anaylsisModuleSlice.reducer;
